export default __webpack_public_path__ + "static/media/image-45.1f586bb9.png";